import { useEffect, useState } from 'react';

/**
 * Decides whether to render the custom cursor at all.
 * Disabled on touch devices, Safari (rendering glitches), and when the user
 * prefers reduced motion.
 */
export const useCursorSupport = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const supported = !hasTouch && !isSafari && !prefersReducedMotion;
    setEnabled(supported);

    if (supported) {
      document.querySelector('.app-wrapper')?.classList.add('custom-cursor-enabled');
    }
    return () => {
      document.querySelector('.app-wrapper')?.classList.remove('custom-cursor-enabled');
    };
  }, []);

  return enabled;
};
